module.exports = __webpack_public_path__ + "media/images/pc/specials/common/event/event_retouch-79e32ad1abc35d1b4dd9cd1cbf0b661c.jpg";